'use client';

import { Fragment } from 'react';
import ReactDOM from 'react-dom';

interface ExternalLinkProps {
  href: string;
  children: React.ReactNode;
}

export const ExternalLink = (props: ExternalLinkProps) => {
  const { href, children, ...restProps } = props;

  const handleLinkClick = async (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault(); // 阻止默认的链接行为
    window.location.href = href;
  };

  const ExternalPrefetchTag = () => {
    if (ReactDOM?.prefetchDNS) {
      ReactDOM.prefetchDNS(href);
    }
    return '';
  };

  return (
    <Fragment>
      <ExternalPrefetchTag />
      <a href={href} onClick={handleLinkClick} {...restProps}>
        {children}
      </a>
    </Fragment>
  );
};

export default ExternalLink;
